export enum DropdownRole {
  Owner = 'Owner',
  Editor = 'Editor',
  Viewer = 'Viewer',
}
